const courses = [
    {
      id: 1,
      title: 'Computer CIT',
      description:
        'Learn the essentials of computer literacy, including basic hardware and software operations. This course covers fundamental skills such as operating systems, word processing, spreadsheets, and internet browsing. Ideal for beginners aiming to become proficient in everyday computer use. Provides foundational knowledge for further technical education. Perfect for students, professionals, and anyone looking to improve computer proficiency.',
      image: '/citbanner.jpg',
    },
    {
      id: 2,
      title: 'Amazon Virtual Assistant',
      description:
        'Become skilled in assisting Amazon sellers with their online businesses. Learn product research, listing optimization, order processing, customer service, and inventory management. The course teaches best practices for managing Amazon Seller Central accounts. Equip yourself with valuable skills to work remotely as a virtual assistant. Suitable for individuals interested in e-commerce and online freelancing.',
      image: '/amazonvabanner.jpg',
    },
    {
      id: 3,
      title: 'Office Automation',
      description:
        'Master the automation tools used in modern offices, including document management, email handling, and scheduling systems. Learn how to automate repetitive office tasks to increase efficiency and productivity. The course includes training on office software like Microsoft Office Suite and Google Workspace. Ideal for administrative professionals and office managers. Gain the skills to streamline daily office operations.',
      image: '/officeautomationbanner.jpg',
    },
    {
      id: 4,
      title: 'Advanced Web Development',
      description:
        'Dive deep into modern web technologies and frameworks like React, Angular, and Node.js. Build dynamic, responsive, and scalable websites and web applications. The course covers both front-end and back-end development techniques. Explore topics like RESTful APIs, databases, and server management. Ideal for aspiring web developers looking to enhance their skills.',
      image: '/webdevelopmentbanner.png',
    },
    {
      id: 5,
      title: 'Mobile Application Development',
      description:
        'Learn how to develop applications for mobile devices using platforms like Android and iOS. This course covers app architecture, user interface design, and coding in languages such as Java, Swift, and Kotlin. Understand mobile app deployment and maintenance. Suitable for anyone aiming to create user-friendly mobile applications. Gain hands-on experience by building functional apps.',
      image: '/mobiledevbanner.jpg',
    },
    {
      id: 6,
      title: 'Artificial Intelligence',
      description:
        'Explore the foundations of AI, including machine learning, neural networks, and data analysis. Learn how to create AI models to solve complex problems in areas like automation, pattern recognition, and natural language processing. Understand the ethical implications and real-world applications of AI technology. Ideal for tech enthusiasts and professionals interested in emerging technologies. Practical projects will allow hands-on experience with AI tools.',
      image: '/aibanner.jpg',
    },
    {
      id: 7,
      title: 'Programming & Development',
      description:
        'Develop coding skills in various programming languages such as Python, Java, and C++. Learn how to write clean, efficient, and error-free code. The course covers essential algorithms, data structures, and software development methodologies. Gain practical experience by working on real-world projects. Ideal for beginners or those looking to strengthen their programming foundations.',
      image: '/programmingbanner.jpg',
    },
    {
      id: 8,
      title: 'Graphic Designing',
      description:
        'Learn the principles of visual design and develop your creativity with tools like Adobe Photoshop, Illustrator, and InDesign. Create stunning visuals for branding, marketing, and digital media. The course includes color theory, typography, and composition techniques. Ideal for aspiring graphic designers or those looking to improve their design skills. Hands-on projects will help build a strong portfolio.',
      image: '/graphicdesignbanner.jpg',
    },
    {
      id: 9,
      title: 'Digital Forensics & Cyber Security',
      description:
        'Understand the techniques used to investigate cybercrimes and protect digital systems. Learn how to collect and analyze digital evidence, secure networks, and prevent cyber-attacks. The course covers topics like encryption, malware analysis, and data recovery. Ideal for individuals interested in law enforcement or IT security roles. Gain skills to combat cyber threats and protect sensitive information.',
      image: '/cyber.jpg',
    },
    {
      id: 10,
      title: 'E-Commerce',
      description:
        'Learn the ins and outs of setting up and managing an online business. This course covers topics like website development, digital marketing, payment gateways, and inventory management. Gain knowledge about customer behavior, sales strategies, and online advertising. Ideal for entrepreneurs looking to start or scale their e-commerce ventures. Stay ahead in the growing digital marketplace.',
      image: '/ecom.png',
    },
    {
      id: 11,
      title: 'Project Management',
      description:
        'Master the skills needed to manage projects efficiently from start to finish. Learn about project planning, risk management, budgeting, and team leadership. The course covers popular project management methodologies such as Agile and Waterfall. Ideal for professionals aiming to lead successful projects across various industries. Gain the knowledge to ensure project success and timely delivery.',
      image: '/pm.jpeg',
    },
  ];

  export default courses;